import { Suspense } from 'react';
import { CircleLoading } from 'loplat-ui';
import { Routes, Route } from 'react-router-dom';
import routes from './routes';
import WithAuth from './WithAuth';

const Router = () => {
  return (
    <Suspense
      fallback={
        <div
          style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            width: '100%',
            height: '100vh',
          }}
        >
          <CircleLoading size={50} />
        </div>
      }
    >
      <Routes>
        {routes.map((route) => (
          <Route
            key={route.path}
            path={route.path}
            element={
              <WithAuth accessibleBy={route.accessibleBy}>
                <route.element />
              </WithAuth>
            }
          />
        ))}
      </Routes>
    </Suspense>
  );
};

export default Router;
